<template>
  <v-alert
    v-if="getRequirePrepay"
    :type="hasAcknowledgedPayment ? 'success' : 'warning'"
    :text="!hasAcknowledgedPayment"
    class="mt-2"
    outlined
    :icon="false"
    :border="hasAcknowledgedPayment ? 'left' : undefined"
    dense
  >
    <v-checkbox
      v-model="hasAcknowledgedPayment"
      label="I understand payment is required to reserve this order."
      color="green"
      :class="[
        'acknowledge-payment-checkbox mt-0 proxima--font',
        hasAcknowledgedPayment ? 'checked' : 'unchecked',
      ]"
      hide-details
    />
  </v-alert>
</template>

<script>
import { mapGetters } from 'vuex'
import { mapFields } from 'vuex-map-fields'

export default {
  name: 'CheckoutPaymentAcknowledgement',
  components: {},
  data() {
    return {}
  },
  computed: {
    ...mapGetters('shop', ['getRequirePrepay']),
    ...mapFields('cart', ['hasAcknowledgedPayment']),
  },
  methods: {},
}
</script>
